export const DUPLICATE_PLUGIN_COMPONENT =
  '[vue-final-modal] Duplicate registration API key and componentName of VueFinalModal.'

export const DUPLICATE_COMPONENT = '[vue-final-modal] Duplicate registration componentName of VueFinalModal.'
